import { CobaltButton } from '@cae/cobalt-react/components/button';
import { CobaltIconArrowRightSolid } from '@cae/cobalt-react/icons/solid/CobaltIconArrowRightSolid';
import { useLogin } from '@pages/landing/hooks/use-login/useLogin';
import React from 'react';
import { useTranslation } from 'react-i18next';

import styles from './LandingWelcome.module.css';

const LandingWelcome = React.memo(
  (): React.ReactElement => {
    const { t } = useTranslation();
    const { handleLogin, handleEmployeeLogin } = useLogin();

    return (
      <div className={styles.landingWelcome}>
        <div className={styles.landingWelcomeInfo}>
          <h1>
            {t('landingPage.welcome')} <br />
            <span className={styles.landingWelcomeInfoApp}>CAEConnect</span>
          </h1>
          <p data-testid="languageValidationText">
            {t('landingPage.description')}
          </p>

          <CobaltButton
            type="button"
            variant="primary"
            onClick={handleLogin}
            onKeyDown={handleLogin}
            aria-label={t('common.login')}
          >
            {t('common.login')}
            <CobaltIconArrowRightSolid size="medium" />
          </CobaltButton>

          <CobaltButton
            type="button"
            variant="ghost"
            onClick={handleEmployeeLogin}
            onKeyDown={handleEmployeeLogin}
            aria-label={t('common.loginCAEEmployee')}
          >
            {t('common.loginCAEEmployee')}
          </CobaltButton>
        </div>
      </div>
    );
  }
);

LandingWelcome.displayName = 'LandingWelcome';

export { LandingWelcome };
